import type {} from "@lit/react";
import { Badge as BadgeElement, } from "@vaadin/badge/vaadin-badge.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { BadgeElement, };
export type BadgeEventMap = Readonly<{}>;
const events = {} as BadgeEventMap;
export type BadgeProps = WebComponentProps<BadgeElement, BadgeEventMap>;
export const Badge = createComponent({
    elementClass: BadgeElement, events, react: React, tagName: "vaadin-badge"
});
